import React, { useCallback, useRef, useState } from 'react';
import { Bubble } from 'tea-component';
import './index.scss';

interface ITextClampProps {
  text: React.ReactNode;
  rowNum?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  style?: React.CSSProperties;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  closeOnScroll?: boolean;
  bubbleProps?: Record<string, any>;
}

function TextClamp({
  text,
  rowNum = 1,
  placement = 'top',
  style,
  className,
  onClick,
  closeOnScroll = false,
  bubbleProps,
}: ITextClampProps) {
  const textDom = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const isOverflowing = useRef(false);

  const handleMouseEnter = useCallback(() => {
    const el = textDom.current;
    if (!el) return;
    isOverflowing.current =
      el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth;
    if (isOverflowing.current) setVisible(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Bubble
      placement={placement}
      dark
      content={isOverflowing.current ? text : null}
      visible={visible}
      onVisibleChange={setVisible}
      style={style || {}}
      closeOnScroll={closeOnScroll}
      {...(bubbleProps || {})}
    >
      <div
        className={`${className || ''} dbom-text-clamp`}
        style={{ WebkitLineClamp: rowNum }}
        ref={textDom}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {text}
      </div>
    </Bubble>
  );
}

export default React.memo(TextClamp);
